import React, { useRef, useState, useEffect } from "react";
import Header from "../components/Header";
import Projects from "../components/Projects";
import Aesthetics from "../components/Aesthetics";
import Contacts from "../components/Contacts";
import { Container, Typography, CircularProgress, Box } from "@mui/material";
import Layout from "../components/Layout";
import styles from "../styles/Home.module.css";

const imageUrls = ["/rachael-ren-08fVXuXFc98-unsplash.jpg"];

const preloadImages = (imageUrls) => {
	return Promise.all(
		imageUrls.map((url) => {
			return new Promise((resolve, reject) => {
				const img = new Image();
				img.src = url;
				img.onload = resolve;
				img.onerror = reject;
			});
		})
	);
};

const Home = () => {
	const [imagesLoaded, setImagesLoaded] = useState(false);
	const contactRef = useRef(null);

	useEffect(() => {
		preloadImages(imageUrls).then(() => {
			setImagesLoaded(true);
		});
	}, []);

	const handleContactClick = () => {
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<Container disableGutters className={styles.container}>
			{imagesLoaded ? (
				<>
					<Layout>
						<Header onContactClick={handleContactClick} />
					</Layout>
					<Layout>
						<Typography
							variant="h6"
							gutterBottom
							style={{
								marginTop: "15px",
								marginBottom: "60px",
								lineHeight: "1.3"
							}}
						>
							Hello!
							<br />
							I'm Morris, a full stack developer. <br />
							Nothing much to see here, just a place to share my projects <br />
							and some cool experiences :)
							<br />
							<br />
							<Typography
								component="a"
								href="mailto:morris@morrisho.me"
								variant="h6"
								style={{
									color: "inherit",
									textDecoration: "underline",
									cursor: "pointer"
								}}
							>
								morris@morrisho.me
							</Typography>
						</Typography>
					</Layout>
					<Layout>
						<Projects />
					</Layout>
					<Layout>
						<Aesthetics />
					</Layout>
					<Layout>
						<Box ref={contactRef}></Box>
						<Contacts />
					</Layout>
				</>
			) : (
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						height: "100vh"
					}}
				>
					<CircularProgress />
				</Box>
			)}
		</Container>
	);
};

export default Home;
